import { render, staticRenderFns } from "./CostBearersPreviewPdfDocument.vue?vue&type=template&id=0337c4c9&"
import script from "./CostBearersPreviewPdfDocument.vue?vue&type=script&lang=ts&"
export * from "./CostBearersPreviewPdfDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports